export default "__VITE_ASSET__Fnm9tB3h__"